module.exports = __webpack_public_path__ + "img/oci.8b52fe45.svg";